// @flow
import type { AudienceEstimate } from '../../types'
import _ from 'lodash'
import postJson from '../../../services/postJson'
import type { State as AudienceState } from '../../../redux/ducks/audienceEdit/reducers'

export function getData(audienceState: AudienceState) {
  const { providers } = audienceState

  const data: Object = {
    birthday: audienceState.birthday,
    relationship_status: audienceState.relationshipStatus,
    included_group_ids: _.map(_.first(audienceState.includedGroups).value, (group) => group.id),
    excluded_group_ids: _.map(audienceState.excludedGroups, (group) => group.id),
    min_age: audienceState.minAge,
    max_age: audienceState.maxAge,
    sex: audienceState.sex,
    payment_type: audienceState.paymentType,
    placement_type: audienceState.placementTypes[0],
    audience_type: audienceState.audienceType,
    platform: audienceState.platform,
    keywords: _.first(audienceState.keywordsGroups).value,
    provider_demographic_ids: audienceState.demographicIds,
    provider_interest_ids: audienceState.interestIds,
    included_vk_apps: _.isEmpty(_.first(audienceState.includedVkAppsGroups).value)
      ? []
      : _.first(audienceState.includedVkAppsGroups).value.split('\n'),
    excluded_vk_apps: _.isEmpty(audienceState.excludedVkApps)
      ? []
      : audienceState.excludedVkApps.split('\n'),
    included_contact_ids: audienceState.includedContactIds,
    included_segment_ids: audienceState.includedSegmentIds,
    excluded_contact_ids: audienceState.excludedContactIds,
    excluded_segment_ids: audienceState.excludedSegmentIds,
    included_lookalike_segment_ids: audienceState.includedLookalikeSegmentIds,
    included_lookalike_contact_ids: audienceState.includedLookalikeContactIds,
    included_provider_targeting_source_ids: audienceState.includedProviderTargetingSourceIds,
    excluded_provider_targeting_source_ids: audienceState.excludedProviderTargetingSourceIds,
    vk_activity_group_ids: _.map(
      _.first(audienceState.vkActivityGroups).value,
      (group) => group.id
    ),
    fb_ad_interests: _(audienceState.fbAdInterests)
      .map((interest) => _.pick(interest, ['id', 'label']))
      .value(),
    only_travellers: audienceState.onlyTravellers,
    vk_user_devices: audienceState.vkUserDevices,
    vk_position_ids: _.map(audienceState.vkPositions, (position) => position.id),
    fb_position_ids: _.map(audienceState.fbPositions, (position) => position.id)
  }

  if (audienceState.geographyType === 'micro') {
    data.micro_locations = audienceState.localGeo
    data.vk_micro_locations_type = audienceState.vkLocalGeoType
    data.tm_micro_locations_visit_type = audienceState.tmLocalGeoVisitType
    data.tm_micro_locations_loc_type = audienceState.tmLocalGeoLocType
    data.fb_micro_locations_type = audienceState.fbLocalGeoType
  }
  if (audienceState.geographyType === 'cities') {
    data.included_location_ids = _.first(audienceState.includedLocationGroups).value
    data.excluded_location_ids = audienceState.excludedLocationIds
  }

  return { items: [{ type: 'params', audience: data, name: audienceState.name, providers }] }
}

const GET_ESTIMATES_PATH = '/api/v1/estimates'

export default (audienceState: AudienceState): Promise<Array<AudienceEstimate>> => {
  if (audienceState.audienceType === 'product_retargeting') {
    return Promise.reject(new window.Error('Estimates are not supported for product retargeting'))
  }
  return new Promise((resolve, reject) =>
    postJson(GET_ESTIMATES_PATH, getData(audienceState))
      .done(resolve)
      .fail(reject)
  )
}
